import Carousel from './carousel';

class HotspotCarousel extends Carousel {
  constructor(selector: any = '.js-hotspot-carousel', settings: object = {}) {
    const TIME = 8000;
    const SPEED = 800;


    const el = selector instanceof HTMLElement
      ? selector
      : document.querySelector(selector);
    const carousel: HTMLElement | null | undefined = el.closest('.o-hotspot');
    const pagination: HTMLElement | null | undefined = carousel?.querySelector('.o-hotspot-carousel__pagination');

    super(el, {
      ...settings,
      effect: 'slide',
      grabCursor: true,
      speed: SPEED,
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      navigation: {
        prevEl: carousel ? carousel.querySelector('.swiper-button-prev') : '.swiper-button-prev',
        nextEl: carousel ? carousel.querySelector('.swiper-button-next') : '.swiper-button-next',
      },
      autoplay: {
        delay: TIME,
      },
      centeredSlides: false,
      pagination: {
        el: pagination,
        type: 'bullets',
        clickable: true,
      },
      on: {
        afterInit: (swiper: any) => {
          pagination?.style.setProperty('--time', `${(TIME + (SPEED / 2)) / 1000}s`);
        },
      },
    });
  }
}

export default HotspotCarousel;
